import { FC } from "react";
import { useEffect, useState } from "react";
import { Outlet, useLoaderData, useLocation } from "react-router-dom";
import Navbar from "../../Container/Navbar";
import Sidebar from "../../Container/Sidebar";

export type Profile = {
  nickname: string;
  position: string;
};

const AppLayout: FC = () => {
  const data = useLoaderData() as Profile;
  const location = useLocation();
  const [isSidebarOpen, setIsSidebarOpen] = useState(false);
  const [isMobileViewport, setIsMobileViewport] = useState(false);

  useEffect(() => {
    const mediaQuery = window.matchMedia("(max-width: 959px)");
    const updateViewport = () => {
      setIsMobileViewport(mediaQuery.matches);
    };

    updateViewport();
    mediaQuery.addEventListener("change", updateViewport);
    return () => {
      mediaQuery.removeEventListener("change", updateViewport);
    };
  }, []);

  useEffect(() => {
    setIsSidebarOpen(false);
  }, [location.pathname]);

  useEffect(() => {
    if (!isSidebarOpen) {
      return undefined;
    }

    const closeOnEscape = (event: KeyboardEvent) => {
      if (event.key === "Escape") {
        setIsSidebarOpen(false);
      }
    };

    window.addEventListener("keydown", closeOnEscape);
    return () => {
      window.removeEventListener("keydown", closeOnEscape);
    };
  }, [isSidebarOpen]);

  return (
    <div className="min-h-screen overflow-x-hidden bg-blue-gray-50">
      <Navbar
        name={data.nickname}
        isMenuOpen={isSidebarOpen}
        onMenuClick={() => {
          setIsSidebarOpen((isOpen) => !isOpen);
        }}
      />
      <Sidebar
        isOpen={isSidebarOpen}
        isMobileViewport={isMobileViewport}
        position={data.position}
        onClose={() => {
          setIsSidebarOpen(false);
        }}
      />
      <main className="min-h-screen min-w-0 overflow-x-hidden pt-16 lg:pl-72">
        <div className="mx-auto min-w-0 max-w-[1600px] px-4 py-5 sm:px-6 sm:py-6 lg:px-8">
          <Outlet />
        </div>
      </main>
    </div>
  );
};

export default AppLayout;
